var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('iframe',{staticClass:"mt-1",staticStyle:{"border":"inset 3px black"},attrs:{"width":"100%","height":"650","src":_vm.URLPDF}})])}
var staticRenderFns = []

export { render, staticRenderFns }